import { useState, useEffect } from 'react'
import './introduce.less'

interface PropsTypes {
  lang: Lang
}

interface VideoName {
  cn: string
  en: string
}

interface AdvantageTypes {
  imgUrl: string
  title: string
  desc: string
  alt: string
}

const advantage: AdvantageTypes[] = [
  {
    imgUrl: require('../../img/introduce/introduce_1.png'),
    title: __('All-in-One Service for Cross-border E-commerce'),
    desc: __('Start your e-business right away by creating an online store with a few clicks. No more struggling with purchasing, warehousing, inspection, logistics and return & exchange.'),
    alt: __('buckydrop drop-shipping image'),
  },
  {
    imgUrl: require('../../img/introduce/introduce_2.png'),
    title: __('Automatic Purchase & Shipment to Easily Grow Your Business'),
    desc: __('Enable highly efficient order management via Order and Parcel Auto-Processing as per your settings, with no need for manual operation 24*7.'),
    alt: __('buckydrop drop-shipping image'),
  },
  {
    imgUrl: require('../../img/introduce/introduce_3.png'),
    title: __('Diversified & Custom Services to Fit You Best'),
    desc: __('Not only standard services, BuckyDrop also provides custom services to help you win the competition. Custom production & packaging, manual operation, multi-source procurement, parcel consolidation and more. You Name It, We Have It. E-commerce business has never been this easier!'),
    alt: __('buckydrop drop-shipping image'),
  },
  {
    imgUrl: require('../../img/introduce/introduce_4.png'),
    title: __('Abundant Chinese Products & Multiple Currencies/Payment Methods Supported'),
    desc: __('Source tons of quality Chinese products from major marketplaces like Taobao, Tmall and JD.com like a breeze!'),
    alt: __('buckydrop drop-shipping image'),
  },
  {
    imgUrl: require('../../img/introduce/introduce_5.png'),
    title: __('Expert Warehousing & Value-added Services to Ensure Worry-free Deliveries'),
    desc: __('Multiple warehouses based in mainland China to receive products. With professional inbound inspection and in-warehouse services, your parcel is in good hands!'),
    alt: __('buckydrop drop-shipping image'),
  },
  {
    imgUrl: require('../../img/introduce/introduce_6.png'),
    title: __('Global Shipment With Various Shipping Plans'),
    desc: __('Global shipment to 200+ countries/regions supported by various highly cost-competitive shipping lines!'),
    alt: __('buckydrop drop-shipping image'),
  },
]

function Introduce (props: PropsTypes): JSX.Element {
  const { lang } = props
  const CDN_PATH = '//cdn.buckydrop.com/media/'
  const VIDEO_NAME: VideoName = {
    cn: 'BuckyDrop-Chinese-Version.mp4',
    en: 'BuckyDrop-English-version-20200825.mp4',
  }

  const [controls, setControls] = useState<boolean>(false)
  const [paused, setPaused] = useState<boolean>(true)
  const [posterVisible, setPosterVisible] = useState<boolean>(true)
  const [index, setIndex] = useState(0)
  const canSlideNum = (advantage.length / 3) - 1 // 可滑动次数

  let videoDom: HTMLVideoElement | null

  const handlePlay = (): void => {
    if (!videoDom) return
    videoDom.play()
  }

  const toLeft = () => {
    // 到 0 之后不可再减
    if (index !== 0) {
      const usersContent = document.getElementById('introduce_advantage_content') as HTMLElement
      usersContent.style.right = `${1200 * (index - 1)}px`
      setIndex(index - 1)
    }
  }

  const toRight = () => {
    // 到最大滑动次数时不可再增
    if (index < canSlideNum) {
      const usersContent = document.getElementById('introduce_advantage_content') as HTMLElement
      usersContent.style.right = `${1200 * (index + 1)}px`
      setIndex(index + 1)
    }
  }

  useEffect(() => {
    const usersContent = document.getElementById('introduce_advantage_content') as HTMLElement
    usersContent.style.width = `${1200 * (advantage.length / 3)}px`
  })

  return (
    <div className={`introduce ${lang}`}>
      <h2 className='introduce_title'>{__('All you need is 2 minutes to know BuckyDrop')}</h2>
      <p className='introduce_desc'>{__('Join us to start your e-commerce dropshipping business for free.')}</p>

      <div className='video_wrap'>
        <div
          className='video_content'
          onMouseEnter={() => {
            setControls(true)
          }}
          onMouseLeave={() => setControls(true)}
        >
          <video
            poster='https://img1.superbuy.com/images/p/2017/11/24/hCQwJAcnXTFMmXM4T6Tz8TPz4NJze4.jpg'
            onPlay={() => {
              setPaused(false)
              setPosterVisible(false)
            }}
            onPause={() => setPaused(true)}
            ref={e => videoDom = e}
            controls={controls}
            className='video_content_video'
            preload='auto'
            src={CDN_PATH + VIDEO_NAME[lang]}
          />
          {paused && <i className='video_content_play' onClick={handlePlay} />}
          {/* poster设置闪逝 故而用图片遮盖 */}
          {
            posterVisible && (
              <img
                className='video_wrap_img'
                src={require('../../img/introduce/poster.jpg')} alt='buckydrop dropshipping video poster'
                onClick={handlePlay}
              />
            )
          }
        </div>
      </div>

      <div className='introduce_advantage'>
        <h2 className='introduce_advantage_title'>{__('Why BuckyDrop')}</h2>
        <p className='introduce_advantage_desc'>{__('A leading service provider with the best solution to cover your cross-border e-business needs')}</p>
        <div className='introduce_advantage_outerContainer'>
          <img className={`users_arrowLeft ${index === 0 ? 'users_arrowLeft_none' : ''}`} src={`${index === 0 ? require('../../img/arrow_left_gray.svg') : require('../../img/arrow_left.svg')}`} alt='buckydrop dropshipping arrow' onClick={toLeft} />
          <img className={`users_arrowRight ${index === canSlideNum ? 'users_arrowRight_none' : ''}`} src={`${index === canSlideNum ? require('../../img/arrow_right_gray.svg') : require('../../img/arrow_right.svg')}`} alt='buckydrop dropshipping arrow' onClick={toRight} />

          <div className='introduce_advantage_container'>
            <div className='introduce_advantage_content' id='introduce_advantage_content'>
              {
                advantage.map((item, index) => (
                  <div className='introduce_advantage_box' key={index}>
                    <img className='introduce_advantage_box_img' src={item.imgUrl} alt={item.alt} />
                    <h4 className='introduce_advantage_box_title'>{item.title}</h4>
                    <p className='introduce_advantage_box_desc'>{item.desc}</p>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Introduce
